import React from 'react';

const INK   = '#2B2620';
const STONE = '#8C8275';
const PAPER = '#FDFBF8';
const FONT_DISPLAY = "'Fraunces', Georgia, serif";
const FONT_SANS    = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export default function MonthlySummaryCard({ title, value, subtitle, Icon, color = '#8B4513' }) {
  return (
    <div style={{
      padding: '20px',
      background: PAPER,
      borderRadius: '14px',
      border: '1px solid rgba(139,69,19,0.1)',
      boxShadow: '0 2px 12px rgba(139,69,19,0.06)',
      transition: 'all 0.2s',
      fontFamily: FONT_SANS,
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-4px)';
      e.currentTarget.style.boxShadow = '0 8px 24px rgba(139,69,19,0.14)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 2px 12px rgba(139,69,19,0.06)';
    }}
    >
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        marginBottom: '12px'
      }}>
        <div style={{
          fontSize: '11px',
          fontWeight: '700',
          color: STONE,
          textTransform: 'uppercase',
          letterSpacing: '0.06em'
        }}>
          {title}
        </div>

        {Icon && (
          <div style={{
            width: '30px', height: '30px', borderRadius: '8px',
            background: `${color}15`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}>
            <Icon size={15} strokeWidth={2} color={color} />
          </div>
        )}
      </div>

      <div style={{
        fontFamily: FONT_DISPLAY,
        fontSize: '34px',
        fontWeight: 600,
        color: INK,
        marginBottom: '4px',
        lineHeight: 1
      }}>
        {value}
      </div>

      {subtitle && (
        <div style={{
          fontSize: '12px',
          color: STONE
        }}>
          {subtitle}
        </div>
      )}
    </div>
  );
}
